module.exports = __webpack_public_path__ + "static/media/StudentContent1.8c9f50ba.svg";